import { Injectable } from '@angular/core';
import { IModalConfig, ISecret, ISecretPayload, NotebookSecretFacade } from '@mode/notebooks/contract';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as SecretActions from './notebook-secret.actions';
import * as SecretSelectors from './notebook-secret.selectors';
import * as LegacyNotebookSelectors from '../notebook/legacy-notebook.selectors';

@Injectable()
export class NotebookSecretService implements NotebookSecretFacade {
  public secrets$: Observable<ISecret[]>;
  public isSecretsExist$: Observable<boolean>;
  public notebookToken$: Observable<string>;
  public secretKeys$: Observable<string[]>;
  public notebookSession$: Observable<any>;

  constructor(private store: Store) {
    this.secrets$ = this.store.select(SecretSelectors.selectSecrets);
    this.isSecretsExist$ = this.store.select(SecretSelectors.isSecretsExist);
    this.notebookToken$ = this.store.select(LegacyNotebookSelectors.notebookToken);
    this.secretKeys$ = this.store.select(SecretSelectors.selectSecretKeys);
    this.notebookSession$ = this.store.select(LegacyNotebookSelectors.notebookSession);
  }

  public loadSecrets(): void {
    this.store.dispatch(SecretActions.loadSecret());
  }

  public createSecret(payload: ISecretPayload): void {
    this.store.dispatch(SecretActions.createSecret({ payload }));
  }

  public editSecret(secretId: string, payload: ISecretPayload): void {
    this.store.dispatch(SecretActions.editSecret({ secretId, payload }));
  }

  public deleteSecret(secretId: string): void {
    this.store.dispatch(SecretActions.deleteSecret({ secretId }));
  }

  public openDeleteSecretModal(secret: ISecret, modalConfig: IModalConfig, cb: () => void): void {
    this.store.dispatch(SecretActions.openDeleteSecretModal({ secret, modalConfig, cb }));
  }
}
